export const Types = {
    GET_SHIFTPLANS: "GET_SHIFTPLANS",
    SET_SHIFTPLANS: "SET_SHIFTPLANS",
    ADD_SHIFTPLAN: "ADD_SHIFTPLAN",
    UPDATE_SHIFTPLAN: "UPDATE_SHIFTPLAN",
    DELETE_SHIFTPLAN: "DELETE_SHIFTPLAN",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getShiftPlans = () => {
    return {
        type: Types.GET_SHIFTPLANS,
    };
};

export const setShiftPlans = (payload) => {
    return {
        type: Types.SET_SHIFTPLANS,
        payload: payload,
    };
};

export const addShiftPlan = (payload) => {
    return {
        type: Types.ADD_SHIFTPLAN,
        payload: payload,
    };
};

export const updateShiftPlan = (payload) => {
    return {
        type: Types.UPDATE_SHIFTPLAN,
        payload: payload,
    };
};

export const deleteShiftPlan = (payload) => {
    return {
        type: Types.DELETE_SHIFTPLAN,
        payload: payload,
    };
};

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
